import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

const armazenar = (todos) => {
  return {
    type: "TODOS",
    todos
  }
}

const erro = (erro) => {
  if (erro.response.data.error.statusCode === 401) {
    axios.defaults.headers.common['Authorization'] = "";
    return {
      type: "LOGOUT"
    }
  }
  return {
    type: "ERRO",
    erro
  }
}

export const buscarNomesArquivosFechamentoPorContrato = (numero) => {
  return dispatch => {
    return axios.get(`${REQUEST_URL}/nomesArquivosFechamentos?filter={"where":{"contrato":${numero}}}`).then((response) => {
      dispatch(armazenar(response.data));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/NomesArquivosFechamentoAction.js